<div class="smartmap-container" #smartmap></div>